import { render } from "./mapLagend.vue?vue&type=template&id=a1b2a3d4&scoped=true"
import script from "./mapLagend.vue?vue&type=script&lang=js"
export * from "./mapLagend.vue?vue&type=script&lang=js"

import "./mapLagend.vue?vue&type=style&index=0&id=a1b2a3d4&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b2a3d4"]])

export default __exports__